import { PathogenTypeEnumDto } from "@agent/data/dto/agent.dto";
import { PathogenTypeEnum } from "@agent/domain/models/agent.model";
import type { Nullable } from "@core/domain/types/nullable.type";
import { injectable } from "inversify";

@injectable()
export class PathogenTypeEnumMapper {
    map(
        pathogenTypeEnumDto: Nullable<PathogenTypeEnumDto>,
    ): Nullable<PathogenTypeEnum> {
        switch (pathogenTypeEnumDto) {
            case PathogenTypeEnumDto.BACTERIA:
                return PathogenTypeEnum.BACTERIA;
            case PathogenTypeEnumDto.INSECTO:
                return PathogenTypeEnum.INSECTO;
            case PathogenTypeEnumDto.HONGO:
                return PathogenTypeEnum.HONGO;
            case PathogenTypeEnumDto.VIRUS:
                return PathogenTypeEnum.VIRUS;
            default:
                return null;
        }
    }

    mapToDto(
        pathogenTypeEnum: PathogenTypeEnum,
    ): Nullable<PathogenTypeEnumDto> {
        switch (pathogenTypeEnum) {
            case PathogenTypeEnum.BACTERIA:
                return PathogenTypeEnumDto.BACTERIA;
            case PathogenTypeEnum.INSECTO:
                return PathogenTypeEnumDto.INSECTO;
            case PathogenTypeEnum.HONGO:
                return PathogenTypeEnumDto.HONGO;
            case PathogenTypeEnum.VIRUS:
                return PathogenTypeEnumDto.VIRUS;
            default:
                return null;
        }
    }
}
